import { render, staticRenderFns } from "./AdFormSiteheader.vue?vue&type=template&id=3bb7c6d2"
import script from "./AdFormSiteheader.vue?vue&type=script&lang=ts"
export * from "./AdFormSiteheader.vue?vue&type=script&lang=ts"
import style0 from "./AdFormSiteheader.vue?vue&type=style&index=0&id=3bb7c6d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports